// Client-side helpers for reasoning about a user's stored GPS location.
// Mirrors the server logic in server/utils/geo.js so the UI agrees with the API.

// Legacy New Delhi placeholder saved by older app versions when location was denied.
const LEGACY_PLACEHOLDERS = [[77.209, 28.6139]];
const PLACEHOLDER_EPSILON = 0.0005;

const isLegacyPlaceholder = (lng, lat) =>
  LEGACY_PLACEHOLDERS.some(
    ([plng, plat]) =>
      Math.abs(lng - plng) < PLACEHOLDER_EPSILON &&
      Math.abs(lat - plat) < PLACEHOLDER_EPSILON
  );

/**
 * Normalize various coordinate shapes to a clean [lng, lat] pair, or null.
 * Accepts: [lng,lat] | { coordinates: [lng,lat] }
 * Rejects: [0,0], the legacy Delhi placeholder, and out-of-range values.
 */
export const normalizeCoords = (input) => {
  if (!input) return null;
  const pair = Array.isArray(input) ? input : input.coordinates;
  if (!Array.isArray(pair) || pair.length < 2) return null;

  const lng = Number(pair[0]);
  const lat = Number(pair[1]);
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null;
  if (lng === 0 && lat === 0) return null;
  if (isLegacyPlaceholder(lng, lat)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;

  return [lng, lat];
};

/**
 * Does this address object have a usable GPS location?
 * `address.coordinates` may be a GeoJSON object or a raw [lng,lat] array.
 */
export const hasValidLocation = (address) => {
  if (!address) return false;
  return normalizeCoords(address.coordinates) !== null;
};
